import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import preloader from "../../../../helpers/preloader";
import showNotification from "../../../../helpers/show_notification";
import { ExportAvailableInCSVForReports, formatUnitsForReport } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";

const ExpiredInventory = (props) => {
  
  const { SearchBar } = Search;
  const store_id = localStorage.getItem("store_id")
  useEffect(() => {
    loadProducts();
  }, []);
  const [currentDate] = useState(() => {
    var d1 = new Date();
    var d = moment(d1).add(1, "days").toDate();
    var month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  });
  const [allProducts, setAllProduucts] = useState([]);
  const loadProducts = async () => {
    preloader(true);
    let url =
      process.env.REACT_APP_BASEURL + "branchproductinventories/expired";
    const response = await postSubmitForm(url, {store_id});
    if (response && response.status === 1) {
      preloader(false);
      setAllProduucts(response.data);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  const [editProductExpiryModal, setEditProductExpiryModal] = useState();
  const [selectedProductForExpiryDate, setSelectedProductForExpiryDate] =  useState();
  const columns = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      csvExport: false,
    },
    {
      text: props.t("Name"),
      dataField: "product_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    {
      dataField: "product_details.section",
      text: props.t("Section"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    {
      dataField: "product_details.category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },

    {
      dataField: "quantity",
      text: props.t("Quantity"),
      formatter:(cell,row)=>{
        return formatUnitsForReport(row.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },

    {
      dataField: "expiry_date",
      text: props.t("Expiry Date"),
      formatter: (cell, row) => {
        return (
          <>
            <span className="mr-4">
              {moment(row.expiry_date).format("DD-MM-YYYY ")}
            </span>
            <i
              className="bx bxs-edit font-size-14"
              title="Click to Edit"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                setEditProductExpiryModal(!editProductExpiryModal);
                setSelectedProductForExpiryDate(row);
                e.stopPropagation();
              }}
            ></i>
          </>
        );
      },
      csvFormatter: (cell, row) =>
        moment(row.expiry_date).format("DD-MM-YYYY "),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
  ];
  const [selectedProducts, setSelectedProducts] = useState([]);
  const handleOnSelectRow = (row, isSelect) => {
    let arrAllProd = JSON.parse(JSON.stringify(allProducts));
    let arrSelectedProd = JSON.parse(JSON.stringify(selectedProducts));
    let selectedProd = arrAllProd.filter((prod) => {
      return prod._id === row._id;
    });
    if (isSelect) {
      arrSelectedProd.push(selectedProd[0]._id);
    } else {
      let index = arrSelectedProd.indexOf(selectedProd[0]._id);
      if (index != -1) {
        arrSelectedProd.splice(index, 1); // remove 1 element from index
      }
    }

    setSelectedProducts(arrSelectedProd);
    return true;
  };
  const handleOnSelectAllRows = (is_selected, rows) => {
    let arrAllProd = JSON.parse(JSON.stringify(allProducts));
    if (is_selected) {
      let arrSelectedProd = [];
      arrAllProd.map((prod) => {
        arrSelectedProd.push(prod._id);
      });
      setSelectedProducts(arrSelectedProd);
    } else {
      setSelectedProducts([]);
    }
  };
  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    onSelect: handleOnSelectRow,
    onSelectAll: handleOnSelectAllRows,
  };

  const [isDisabled, setIsDisabled] = useState(false)
  const handleDiscardAsExpired = async () => {
   try {
    setIsDisabled(true);
    const object = {
      branchproductinventory_ids: selectedProducts,
    };
    let url =
      process.env.REACT_APP_BASEURL + "branchproductinventories/discard";
    const response = await postSubmitForm(url, object);
    if (response && response.status === 1) {
      loadProducts();
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
   } catch (error) {
    console.log(error);
   } finally {
    setIsDisabled(false);
   }
  };
  const handleUpdateProductExpiry = async (e, v) => {
    const object = {
      branchproductinventory_id: selectedProductForExpiryDate._id,
      expiry_date: v.expiry_date,
    };
    let url =
      process.env.REACT_APP_BASEURL + "branchproductinventories/update_expiry";

    const response = await postSubmitForm(url, object);

    if (response && response.status === 1) {
      loadProducts();
      showNotification(response.message, "Success");
      setEditProductExpiryModal(!editProductExpiryModal);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const handleDownload = async () => {
    const fileName = "expired_finished_product_inventory";
    const exportType = "xls";

    let data_to_export = allProducts;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          Name: v.product_details.name,
          Section: v.product_details.section,
          Category: v.product_details.category,
          quantity:v.quantity.length > 0 ? ExportAvailableInCSVForReports(v.quantity) : " ",
          Threshold: v.threshold + " " + v.unit_for_threshold,
          Expiry_Date: moment(v.expiry_date).format("DD-MM-YYYY "),
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t(
              "View/ Discard Expired Finished Product Inventory"
            )}
            title={props.t("Inventory")}
            breadcrumbItem1={props.t("Products")}
            breadcrumbItem2={props.t("Expired Finished Product Inventory")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Expired Finished Product Inventory")}
                    </CardTitle>

                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allProducts && allProducts}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                      exportCSV
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={8}>
                              <Row>
                                <Col lg={6}>
                                  <SearchBar
                                    {...props.searchProps}
                                    style={{ width: "300px" }}
                                  />
                                </Col>
                                <Col lg={6}></Col>
                              </Row>
                            </Col>

                            <Col lg={4} className="text-right">
                              {selectedProducts &&
                                selectedProducts.length > 0 && (
                                  <Button
                                    className="btn btn-sm btn-danger"
                                    onClick={handleDiscardAsExpired}
                                    disabled={isDisabled}
                                  >
                                    <i className="bx bx-trash"></i> Discard
                                    Selected
                                  </Button>
                                )}
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                            selectRow={selectRow}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                  <Modal
                    size="md"
                    isOpen={editProductExpiryModal}
                    toggle={() =>
                      setEditProductExpiryModal(!editProductExpiryModal)
                    }
                  >
                    <ModalHeader
                      toggle={() =>
                        setEditProductExpiryModal(!editProductExpiryModal)
                      }
                    >
                      {props.t("Product")}:{" "}
                      {selectedProductForExpiryDate &&
                        selectedProductForExpiryDate.product_details.name}
                    </ModalHeader>
                    <ModalBody>
                      {selectedProductForExpiryDate && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <AvForm
                                    onValidSubmit={handleUpdateProductExpiry}
                                  >
                                    <Row>
                                      <Col lg={12}>
                                        <Label>
                                          {props.t("Current Expiry Date")}:{" "}
                                          {selectedProductForExpiryDate &&
                                            moment(
                                              selectedProductForExpiryDate.expiry_date
                                            ).format("DD-MM-YYYY ")}
                                        </Label>

                                        <hr />
                                      </Col>

                                      <Col lg={12}>
                                        <Label>
                                          {props.t("Updated Expiry Date")}{" "}
                                        </Label>

                                        <AvField
                                          name="expiry_date"
                                          placeholder={props.t(
                                            "Select Expiry Date"
                                          )}
                                          type="date"
                                          min={currentDate}
                                          required
                                          errorMessage="Expiry date cannot be empty"
                                        />
                                      </Col>

                                      <Col lg={12}>
                                        <hr />
                                        <FormGroup className="mb-0 text-center">
                                          <div>
                                            <Button
                                              type="submit"
                                              color="primary"
                                              className="mr-1"
                                            >
                                              {props.t("Update")}
                                            </Button>{" "}
                                          </div>
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </AvForm>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ExpiredInventory))
);
